module.exports = __webpack_public_path__ + "static/media/natsu.51d58dea.webp";